import clsx from "clsx";
import { PropsWithChildren } from "react";

export type PropertiesProps = {
  sliderMode?: boolean;
};

// TODO: [NVS-3331] Make this part of a design system component <ScrollSnap.Item>
export const sliderItemClass = "w-max snap-start";

const Properties = ({
  sliderMode = true,
  ...props
}: PropsWithChildren<PropertiesProps>) => {
  return (
    <ul
      className={clsx(
        "gap-3",
        // TODO: [NVS-3331] Make this a design system component <ScrollSnap> and remove this slider option
        sliderMode
          ? "grid snap-x snap-mandatory auto-cols-max grid-flow-col overflow-x-auto lg:flex lg:flex-wrap"
          : "flex flex-col",
      )}
    >
      {props.children}
    </ul>
  );
};

export default Properties;
